/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable no-irregular-whitespace */
/* eslint-disable no-tabs */
import { memo, useState } from 'react';
import { CKEditor } from 'ckeditor4-react';
import { Grid, makeStyles } from '@material-ui/core';
import { getEnvVariable } from '../../../commonFunction/getEnv';
import NormalTooltip from '../../styles/tooltip';

const useStyles = makeStyles(() => ({
  wrap: {
    width: '74.5%',
  },
  full: {
    width: '100%',
  },
}));

function MailTitleAndBody(props) {
  const {
    initData = '',
    setMailBody = () => {},
    disable = false,
    full = false,
    getOwnLibrary = () => {},
    isActiveSaveTemplate = false, // テンプレ保存ボタンの表示/非表示
    isLibraryOpen = { create: false, edit: false },
    setIsLibraryOpen = () => {},
    errorCallback = () => () => {},
  } = props;
  const classes = useStyles();
  const [hasUrlPathError, setHasUrlPathError] = useState(false);

  const FILESTORAGE_UUID_STRING_LENGTH = 64;

  // テンプレ保存ボタンのロジック
  // プラグイン側のsavetemplateと連動しているため注意
  const handlePluginLoaded = (e) => {
    e?.editor?.addCommand('savetemplate', {
      readOnly: true, // 読み取りモードでも押せるようにする
      exec: async () => {
        if (!isActiveSaveTemplate) return;
        await getOwnLibrary();
        setIsLibraryOpen({ ...isLibraryOpen, create: true });
      },
    });
  };

  // メール本文内のファイルストレージのURLが適正か判断する(OH_KDSFA-1953)
  const validateUrlPathInMailBody = (data) => {
    const baseUrl = `${getEnvVariable('LASTA_BASE_URL')}filedownload/`;
    const hasFileStorageUrl = data.includes(baseUrl);
    let result = false;
    if (hasFileStorageUrl) {
      // 1つずつURLのパスを確認(パス末尾の文字数がuuidの長さと一致する場合OKとする)
      const regex = new RegExp(`^[a-fA-F0-9]{${FILESTORAGE_UUID_STRING_LENGTH}}(?=[^a-fA-F0-9]|$)`);
      const words = data.trim().split(/\s+/);
      words.forEach((word) => {
        if (word.includes(baseUrl)) {
          const url = word.replace(/<[^>]*>/g, '');
          const lastSegment = url.split('/').pop();
          if (!regex.test(lastSegment)) {
            result = true;
          }
        }
      });
    }
    errorCallback('mailbody')(result);
    setHasUrlPathError(result);
  };

  // memo: onBlurの場合、以下の理由で期待される動作にならなかった
  // onBlur->onClick と走るものの、useStateの更新が反映される前の為に登録内容と表示に差異が出る
  const handleChange = (event) => {
    const data = event?.editor?.getData?.() ?? '';
    validateUrlPathInMailBody(data);
    setMailBody(data);
  };

  const handleLoaded = () => {
    // 下記Issueにて、CKEditor4にはmodal等で"tabIndex='-1'"が設定されている場合、input要素が入力できない問題が挙げられている
    // Material UI側ではPropsによる設定ができなかった為、querySelectorで暫定対応
    // ref: Can't type in fields · Issue #3555 · ckeditor/ckeditor4 · GitHub
    // link: https://github.com/ckeditor/ckeditor4/issues/3555
    const muiModals = document.getElementsByClassName(
      'MuiDialog-container MuiDialog-scrollPaper',
    );
    for (let i = 0; i < muiModals.length; i += 1) {
      muiModals?.[i]?.removeAttribute('tabIndex');
    }
  };

  return (
    <Grid item className={full ? classes.full : classes.wrap}>
      <NormalTooltip title={hasUrlPathError ? 'ファイルストレージのURLが正しくない可能性があります。' : ''}>
        <div>
          <CKEditor
            config={!isActiveSaveTemplate ? { removeButtons: 'Anchor,Paste,savetemplate' } : ''}
            initData={initData}
            readOnly={disable}
            onChange={handleChange}
            onLoaded={handleLoaded}
            onPluginsLoaded={handlePluginLoaded}
            editorUrl="/CKEditor/ckeditor.js"
            onMode={(e) => {
              if (e.editor?.mode === 'source') {
                const editable = e.editor.editable();
                editable.attachListener(editable, 'input', (event) => {
                  setMailBody(event.data.$.target.value);
                });
              }
            }} // ソース編集モードでonChangeが動かないためinputイベントで監視
          />
        </div>
      </NormalTooltip>
    </Grid>
  );
}

export default memo(MailTitleAndBody, () => true);
